import { areTypedValuesEqual } from "src/services/typedValue";
import { PropertyValue } from "src/types/property";

export const arePropertyValuesEqual = (value1: PropertyValue, value2: PropertyValue) => {
  if (value1.property.dataType !== value2.property.dataType) {
    return false;
  }

  return areTypedValuesEqual(value1.value, value2.value);
};
